<script setup>
import { shallowRef } from 'vue'

import TextField from './fields/TextField'
import SelectField from './fields/SelectField'
import TextareaField from './fields/TextareaField'
import DateField from './fields/DateField'
import SelectButtonsField from './fields/SelectButtonsField'
import CheckboxField from './fields/CheckboxField'
import SelectCheckboxField from './fields/SelectCheckboxField'
import TreadDepthField from './fields/TreadDepthField'
import DamageItemField from './fields/DamageItemField.vue'
import MileagePhotoField from './fields/MileagePhotoField.vue'
import SignatureField from './fields/SignatureField.vue'
import PhotosField from './fields/PhotosField.vue'
import CustomerField from './fields/CustomerField.vue'
import BikeDamageItemField from './fields/BikeDamageItemField.vue'

const props = defineProps(['field', 'modelValue'])
const emit = defineEmits(['update:modelValue', 'update'])

const selected = shallowRef(null)

const components = {
	'string': TextField,
	'select': SelectField,
	'select-buttons': SelectButtonsField,
	'input-text': TextField,
	'input-number': TextField,
	'input-date': DateField,
	'textarea': TextareaField,
	'checkbox': CheckboxField,
	'select-checkbox': SelectCheckboxField,
	'tread-depth': TreadDepthField,
	'damage-item': DamageItemField,
	'mileage-photo': MileagePhotoField,
	'signature': SignatureField,
	'photos': PhotosField,
	'customer-select': CustomerField,
	'bike-damage-item': BikeDamageItemField,
}

const resolve = () => {
	return components[props.field.type] || TextField
}

selected.value = resolve()
</script>

<template>
<component
	:is="selected"
	:field="field"
	:model-value="modelValue"
	@update:model-value="(val) => {
		if (field.display) emit('update:modelValue', val)
	}"
	@update="emit('update')"
/>
</template>

<style lang="scss" scoped>

</style>